import PageBreadcrumb, {
  PageBreadcrumbItem
} from 'components/common/PageBreadcrumb';
import React, { useEffect, useState } from 'react';
import QuizzesInstruction from './instruction/QuizzesInstruction';
import { Col, Row } from 'react-bootstrap';
import QuizzesTopicCard from './topicCard/QuizzesTopicCard';
import QuizzesTopicFilter from './filter/QuizzesTopicFilter';
import { useLazyFindTopicQuery } from 'service/quizzesQuery/quizzesQuery';
import { Topic } from './quizzes.type';
import AssessmentFallback from 'components/modules/fallback/AssessmentFallback';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import QuizStartAssessmentModal from 'components/modals/QuizStartAssessmentModal';
import { useNavigate } from 'react-router-dom';

export const defaultBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'Core Basics',
    url: '/home/ladder/basic',
    active: true
  }
];

function Quizzes() {
  const user = useSelector((state: RootState) => state.user.user);
  const [fetchTopics, { data = [] }] = useLazyFindTopicQuery();

  const [search, setSearch] = useState('');
  const [selectedTopic, setSelectedTopic] = useState<Topic | null>(null);

  const navigate = useNavigate();

  const onClose = () => {
    setSelectedTopic(null);
  };

  const handleStartExam = () => {
    navigate(`/permission/quiz/${selectedTopic?._id}`);
    onClose();
  };

  useEffect(() => {
    fetchTopics('');
  }, []);

  return (
    <>
      <QuizStartAssessmentModal
        show={!!selectedTopic}
        handleClose={onClose}
        title={selectedTopic?.skill.name}
        desc={selectedTopic?.skill.desc}
        duration={selectedTopic?.duration}
        handleSubmit={handleStartExam}
        loading={false}
      />
      <div>
        <PageBreadcrumb items={defaultBreadcrumbItems} />
        <div className="mb-9">
          <h2 className="mb-4">Core Basics</h2>
          <QuizzesInstruction />
          {Array.isArray(data) && data.length > 0 ? (
            <>
              <QuizzesTopicFilter
                role={user.info?.role?.value}
                onSearchChange={setSearch}
              />
              <Row className="g-3">
                {data
                  .filter(
                    (item: Topic) =>
                      item.skill?.name
                        .toLowerCase()
                        .includes(search.toLowerCase())
                  )
                  .map((topic: Topic) => (
                    <Col xl={6} key={topic._id}>
                      <QuizzesTopicCard
                        topic={topic}
                        onSelect={setSelectedTopic}
                      />
                    </Col>
                  ))}
              </Row>
            </>
          ) : (
            <AssessmentFallback
              message={
                <>
                  You have selected the{' '}
                  <strong>{user.info?.role?.value}</strong> role, but it is
                  currently unavailable. Please check back later for updates.
                </>
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Quizzes;
